import { data } from '../data/data.js';

const Work = () => {
  const project = data;

  return (
    <div name="work" className="w-full min-h-screen bg-[#0a192f] text-gray-300 py-20">
      <div className="max-w-[1000px] mx-auto mb-5 justify-center w-full h-full">
        <div className="pb-8 p-4">
          <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600">Work</p>
          <p className="py-6">Check out some of my recent work</p>
        </div>

        {/* container for projects */}
        <div className="grid sm:grid-cols-2 md:grid-cols-1 gap-5">
          {/* Gird Item */}
          {project.map((item, index) => (
            <div className="grid sm:grid-cols-2 md:grid-cols-2 px-2 py-2">
              <div
                key={index}
                style={{ backgroundImage: `url(${item.image})` }}
                className="shadow-lg shadow-[#040c16] group container rounded-md 
              flex justify-center text-center items-center mx-auto content-div">
                {/* Hover effect for images */}
                <div className="opacity-0 group-hover:opacity-100 ">
                  <span className="text-2xl font bold text-white tracking-wider ">{item.name}</span>
                  <div className="pt-8 text-center ">
                    {/* eslint-disable-next-line */}
                    <a href={item.github} target="_blank">
                      <button
                        className={`text-center rounded-lg px-4 py-3 m-2 font-bold text-lg ${
                          item.github ? 'bg-white text-gray-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                        disabled={!item.github}>
                        Code
                      </button>
                    </a>
                    {/* eslint-disable-next-line */}
                    <a href={item.live} target="_blank">
                      <button
                        className={`text-center rounded-lg px-4 py-3 m-2 font-bold text-lg ${
                          item.live ? 'bg-white text-gray-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                        onClick={() => {
                          if (item.live) {
                            window.open(item.live, '_blank');
                          }
                        }}
                        disabled={!item.live}>
                        Live
                      </button>
                    </a>
                  </div>
                </div>
              </div>
              <div className="items-center mx-auto px-6 py-3 hover:scale-105 transition-transform duration-300 rounded-md">
                {item.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Work;
